import React, { type HTMLAttributes } from 'react';

export type TextTone = 'primary' | 'secondary' | 'muted' | 'subtle' | 'success' | 'danger' | 'warning' | 'info' | 'link';

/** Semantic color only: layout and type size remain owned by the caller. */
export function AppText({ as: Tag = 'span', tone = 'primary', className = '', ...props }: HTMLAttributes<HTMLElement> & {
  as?: 'span' | 'p' | 'small' | 'strong' | 'div'; tone?: TextTone;
}) {
  return <Tag {...props} className={`app-text app-text--${tone} ${className}`} />;
}

export function AppHeading({ level = 1, className = '', ...props }: HTMLAttributes<HTMLHeadingElement> & { level?: 1 | 2 | 3 | 4 | 5 | 6 }) {
  const Tag = `h${level}` as 'h1';
  return <Tag {...props} className={`app-heading ${className}`} />;
}
